import React, { useEffect, useState } from "react";
import { Input } from "../../common/utils/antd-imports/AntdImports";
import "../float-input/FloatInput.css";

const IconFloatingInput = ({
  innerClassName = "",
  label,
  size = "middle",
  width = "100%",
  addon = true,
  customStyles = {},
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [hasValue, setHasValue] = useState(!!props.value);

  const getTextFromReactNode = (node) => {
    if (typeof node === "string") return node;
    if (Array.isArray(node)) return node?.map(getTextFromReactNode)?.join("");
    if (node?.props?.children) return getTextFromReactNode(node.props.children);
    return "";
  };

  useEffect(() => {
    setHasValue(!!props.value);
  }, [props.value]);

  return (
    <div
      className={
        innerClassName.length > 0
          ? innerClassName
          : `floating-input-container ${size}`
      }
      style={{
        width,
        position: "relative",
        ...customStyles,
      }}
    >
      {(isFocused || hasValue) && (
        <label
          className={`floating-label focused`}
          style={{
            "--label-font-size": customStyles["--label-font-size"] || "66px",
            "--label-focused-font-size":
              customStyles["--label-focused-font-size"] || "12px",
            "--label-color": customStyles["--label-color"] || "#333333",
            "--label-focused-color":
              customStyles["--label-focused-color"] || "#f10c0c",
            "--label-focused-top": customStyles["--label-focused-top"] || "0px",
            "--label-focused-z-index":
              customStyles["--label-focused-z-index"] || 0,
            paddingLeft: customStyles["--label-padding-left"] || 0,
          }}
        >
          {label}
        </label>
      )}
      <Input
        {...props}
        size={size}
        addonBefore={addon ? "$" : undefined}
        addonAfter={!addon ? "%" : undefined}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        placeholder={
          isFocused || props.value ? "" : getTextFromReactNode(label)
        }
        style={{
          "--input-border-color":
            customStyles["--input-border-color"] || "#333333",
          "--input-border-color-focused":
            customStyles["--input-border-color-focused"] || "#0c0c0c",
          fontWeight: customStyles["--input-font-weight"] || 400,
        }}
      />
    </div>
  );
};

export default IconFloatingInput;
